// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldEnvelope = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 12',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.30069 0.167763C6.85954 -0.054619 9.43285 -0.054619 11.9917 0.167763L13.2254 0.273902C13.6209 0.308413 14.0014 0.442184 14.3315 0.662827C14.6616 0.883469 14.9307 1.18385 15.1138 1.53614C15.1352 1.57961 15.1394 1.62954 15.1257 1.67599C15.1119 1.72245 15.0811 1.76201 15.0395 1.78679L9.92361 4.95464C9.38518 5.28799 8.76578 5.46764 8.13254 5.47412C7.4993 5.48059 6.87635 5.31365 6.33121 4.99138L1.18183 1.94763C1.14124 1.92468 1.11035 1.8878 1.09489 1.84381C1.07943 1.79982 1.08044 1.75171 1.09774 1.70841C1.26461 1.31281 1.53625 0.970233 1.88342 0.717595C2.23058 0.464957 2.64009 0.311832 3.06784 0.274719L4.30069 0.167763Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.09546 3.3171C1.06629 3.29981 1.03324 3.29013 0.999357 3.28894C0.96547 3.28776 0.931826 3.2951 0.901514 3.31029C0.871201 3.32549 0.845191 3.34806 0.825869 3.37592C0.806547 3.40378 0.794532 3.43606 0.790927 3.46977C0.583905 5.52547 0.634371 7.59898 0.941155 9.64217C1.02049 10.1656 1.27353 10.6471 1.65958 11.0093C2.04563 11.3715 2.54227 11.5934 3.06965 11.6392L4.3025 11.7462C6.86208 11.9691 9.43555 11.9691 11.9951 11.7462L13.228 11.64C13.7556 11.5939 14.2523 11.3716 14.6382 11.0089C15.0242 10.6462 15.2769 10.1642 15.3557 9.64054C15.6713 7.53784 15.7155 5.40329 15.4871 3.28934C15.4832 3.25548 15.4707 3.22317 15.4509 3.1954C15.4312 3.16763 15.4047 3.14531 15.374 3.13049C15.3433 3.11567 15.3094 3.10884 15.2754 3.11063C15.2413 3.11242 15.2083 3.12278 15.1793 3.14074L10.5704 5.99343C9.84214 6.44415 9.00443 6.68705 8.148 6.69583C7.29158 6.70461 6.44907 6.47893 5.7117 6.04324L1.09546 3.3171Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldEnvelope };
